import { IPagination, LoadingStatus } from 'src/types/main';

export const PaginationType = {
  TEXT: 'text',
  ARROW: 'arrow',
} as const;
export type TPaginationType = TValueOf<typeof PaginationType>;

export enum PaginationDirection {
  PREV = 'prev',
  NEXT = 'next',
}

export interface IPageItem {
  value: number;
  label?: string | number;
  isActive?: boolean;
}

export interface IPaginationProps {
  type?: TPaginationType;
  pagination: IPagination<any>;
  onChange: (page: number) => void;
  loading?: LoadingStatus;
  showPaginationInfo?: boolean;
  showMorePageButtons?: boolean;
  hidden?: boolean;
  className?: string;
  overlayClassName?: string;
}
